const theme = {
  blue: "#48abcc",
  black: "#3f403f",
  green: "#accc3d",
  darkGreen: "#2b9f57",
  white: "#fff",
  grey: "#f1f2f2",
};

export default theme;
